import { connect } from 'react-redux';

import {
  GET_BANKING_LIST,
  ADD_BANKING_OF_PLACE,
  UPDATE_BANKING_OF_PLACE,
  REQUEST_UPDATE_BANKING_OF_PLACE,
} from 'store/banking/actionTypes';
import { GET_PLACE_DETAIL } from 'store/place/actionTypes';
import * as Actions from 'store/finance/actions';
import { getInvoices } from 'store/invoice/actions';

import Finance from './Finance';

const mapStateToProps = (state) => ({
  isLoadingGetBankingList: state.Banking.isLoadingGetBankingList,
  isLoadingUpdateBankingOfPlace: state.Banking.isLoadingUpdateBankingOfPlace,

  bankingList: state.Banking.bankingList,
  placeDetail: state.Place.placeDetail,
  me: state.Profile.me,

  finances: state.invoice.invoices,
  financesLoading: state.invoice.invoicesLoading,
  financeOverview: state.finance.financeOverview,
  financeOverviewLoading: state.finance.financeOverviewLoading,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetPlaceDetail: (payload) => dispatch({
    type: GET_PLACE_DETAIL,
    payload,
  }),

  actionGetBankingList: (payload) => dispatch({
    type: GET_BANKING_LIST,
    payload,
  }),

  actionAddBankingOfPlace: (payload) => dispatch({
    type: ADD_BANKING_OF_PLACE,
    payload,
  }),

  actionUpdateBankingOfPlace: (payload) => dispatch({
    type: UPDATE_BANKING_OF_PLACE,
    payload,
  }),

  actionRequestUpdateBankingOfPlace: (payload) => dispatch({
    type: REQUEST_UPDATE_BANKING_OF_PLACE,
    payload,
  }),

  getFinances: (payload) => dispatch(getInvoices(payload)),
  getFinanceOverview: (payload) => dispatch(Actions.getFinanceOverview(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Finance);
